import Vue from "vue";
import Vuex, { Store as store } from "vuex";
import axios from "axios";
import settings from "@/settings";
import router from "@/router";
import moment from "moment";
import rootState from "../index";

Vue.use(Vuex);
let default_event_data = {
    id: null,
    recurring: null,
    notes: null,
    budget: null,
    location: null,
    time: "12:00",
    date: null,
    event_type: null,
    name: null,
    tasks: [],
    parent_event_id: null,
    original_event_id: null,
    attendees: [],
    recurred_item: false,
    guests: []
};
let default_event_task_data = {
    id: null,
    notes: null,
    time: null,
    deadline: null,
    status: null,
    name: null,
    done_date: null,
    event_id: null,
    date: null
};

export default {
    namespaced: true,
    state: {
        guest_ids: [],
        event_task_save_btn_disabled: false,
        save_btn_disabled: true,
        task_event_save_btn_disabled: true,
        save_btn_loading: false,
        event_adding_error: false,
        errors: [],
        user_added_persons_count: 0,
        active_event: {},
        active_people_tab: "adults",
        cal_events_loading: false,
        active_sub_tab: "tasks",
        months: [],
        event_loaded: false,
        global_errors: [],
        task_errors: [],
        event_type_options: [
            { value: "birthday", label: "Birthday" },
            { value: "christmas_party", label: "Christmas party" },
            { value: "dinner_party", label: "Dinner party" },
            { value: "travel", label: "Travel" },
            { value: "event", label: "Event" },
            { value: "team_event", label: "Team event" },
            { value: "wedding", label: "Wedding" }
        ],
        event_recurring_options: [
            { value: "daily", label: "Every day" },
            { value: "weekly", label: "Every week" },
            { value: "every_2_weeks", label: "Every 2 weeks" },
            { value: "monthly", label: "Every month" },
            { value: "yearly", label: "Every year" },
            { value: "never", label: "Never" }
        ],
        active_tab: "list",
        calendar_events: [],
        potential_guests: [],
        event: JSON.parse(JSON.stringify(default_event_data)),
        event_task: JSON.parse(JSON.stringify(default_event_task_data)),
        events: []
    },
    mutations: {
        /**
         * Update event field - https://vuex.vuejs.org/guide/mutations.html
         * @param state
         * @param prop_name
         * @param prop_value
         */
        update_field(state, { prop_name, prop_value }) {
            state.event[prop_name] = prop_value;
        },

        update_event_task_field(state, { prop_name, prop_value }) {
            //Vue.set(state.event_task, prop_name, prop_value)
            state.event_task[prop_name] = prop_value;
            if (state.task_errors) {
                state.task_errors = state.task_errors.filter(item => item !== prop_name);
            }
        },
        change_event_guest_status(state, pl) {
            let event_person = JSON.parse(JSON.stringify(pl.event_person));
            event_person.status = pl.status;
            let index = state.event.guests.findIndex(guest => guest.id === pl.event_person.id);
            Vue.set(state.event.guests, index, event_person);
        },
        set_event_state(state, pl) {
            state.event_loaded = pl;
        },
        set_event(state, event) {
            state.event = event;
            if (state.active_event && state.active_event.date) {
                state.event.date = state.active_event.date;
                state.event.event_time = state.active_event.time;
                state.event.parent_event_id = state.active_event.parent_event_id;
                state.event.original_event_id = state.active_event.original_event_id;
                state.event.recurred_item = state.active_event.recurred_item;
            }
            state.event_loaded = true;
        },
        set_task_event(state, event_task) {
            state.event_task = event_task;
        },
        clear_events(state) {
            state.months = [];
            state.events = [];
            state.calendar_events = [];
        },
        set_cal_events_loading(state, bool) {
            state.cal_events_loading = bool;
        },
        set_active_sub_tab(state, tab) {
            state.active_sub_tab = tab;
        },
        set_active_people_tab(state, tab) {
            state.active_people_tab = tab;
        },
        set_task(state, event_task) {
            /** @namespace rootState.StoreTask */
            state.event_task = event_task;
            state.event_task.event_id = state.event.id;
        },
        add_event_guests(state, payload) {
            state.potential_guests = payload.guests;
            state.user_added_persons_count = payload.user_added_persons_count;
        },
        add_month_events(state, data_arr) {
            let month_events = data_arr.events_data;
            let page = data_arr.page;
            let keysArray = Object.keys(month_events);
            let i;
            if (state.events && state.events.length > 0) {
                let exists = true;
                for (i = 0; i < state.events.length; i++) {
                    if (!state.months.includes(keysArray.toString())) {
                        state.months.push(keysArray.toString());
                        exists = false;
                    }
                }
                if (!exists) {
                    if (page && page < 0) {
                        state.events.push(month_events);
                    } else {
                        state.events.unshift(month_events);
                    }
                }
            } else {
                if (page && page < 0) {
                    state.events.push(month_events);
                } else {
                    state.events.unshift(month_events);
                }
            }
        },

        add_calendar_events(state, data_arr) {
            let month_events = data_arr.events_data;
            let page = data_arr.page;
            if (state.calendar_events && state.calendar_events > 0) {
                if (!state.calendar_events.includes(data_arr)) {
                    if (!page) {
                        state.calendar_events.push(month_events);
                    }
                    if (page && page < 0) {
                        state.calendar_events.push(month_events);
                    } else {
                        state.calendar_events.unshift(month_events);
                    }
                }
            } else {
                if (page && page < 0) {
                    state.calendar_events.push(month_events);
                } else {
                    state.calendar_events.unshift(month_events);
                }
            }
        },
        set_tab(state, tab) {
            state.active_tab = tab;
        },
        set_btn_mode(state, val) {
            state.save_btn_disabled = !val;
        },
        set_active_event(state, val) {
            state.active_event = val;
        },
        set_task_event_btn_mode(state, val) {
            state.task_event_save_btn_disabled = !val;
        },
        set_btn_loading(state, boolean) {
            state.save_btn_loading = boolean;
        },
        set_event_task_save_btn_disabled(state, boolean) {
            state.event_task_save_btn_disabled = boolean;
        },
        set_event_loaded(state, boolean) {
            state.event_loaded = boolean;
        },
        set_events(state, events) {
            state.events = events;
        },
        set_errors(state, errors) {
            state.errors = errors;
        },
        set_guest_ids(state, guest_ids) {
            state.guest_ids = guest_ids;
        },
        set_task_errors(state, errors) {
            state.task_errors = errors;
        },
        set_event_add_error(state, boolean) {
            state.event_adding_error = boolean;
        },
        set_global_errors(state, errors) {
            state.global_errors = errors;
        },
        clear_event(state) {
            state.event = JSON.parse(JSON.stringify(default_event_data));
        },
        clear_task_event(state) {
            state.event_task = JSON.parse(JSON.stringify(default_event_task_data));
        }
    },
    getters: {
        adults: state => {
            if (state.event && state.event.guests && state.event.guests.length > 0) {
                let results = state.event.guests.filter(item => {
                    if (item.person) {
                        return item.person.age_group === "adult";
                    }
                });
                let status_order = ["attending", "pending", "not_attending"];
                results = results.sort((a, b) => {
                    let o = status_order.indexOf(a.status) - status_order.indexOf(b.status);
                    if (o === 0) {
                        if (a.created_at > b.created_at) {
                            o = -1;
                        }
                        if (a.created_at < b.created_at) {
                            o = 1;
                        }
                    }
                    return o;
                });
                return results;
            } else {
                return [];
            }
        },
        potential_guests_adults: state => {
            if (state.potential_guests && state.potential_guests.length > 0) {
                let results = state.potential_guests.filter(item => {
                    if (item) {
                        return item.age_group === "adult";
                    }
                });
                return results;
            } else {
                return [];
            }
        },
        potential_guests_kids: state => {
            if (state.potential_guests && state.potential_guests.length > 0) {
                let results = state.potential_guests.filter(item => {
                    if (item) {
                        return item.age_group === "child";
                    }
                });
                return results;
            } else {
                return [];
            }
        },
        kids: state => {
            if (state.event && state.event.guests && state.event.guests.length > 0) {
                let results = state.event.guests.filter(item => {
                    if (item.person) {
                        return item.person.age_group === "child";
                    }
                });
                let status_order = ["attending", "pending", "not_attending"];
                results = results.sort((a, b) => {
                    let o = status_order.indexOf(a.status) - status_order.indexOf(b.status);
                    if (o === 0) {
                        if (a.created_at > b.created_at) {
                            o = -1;
                        }
                        if (a.created_at < b.created_at) {
                            o = 1;
                        }
                    }
                    return o;
                });
                return results;
            } else {
                return [];
            }
        },
        attending_total: state => {
            if (state.event && state.event.guests && state.event.guests.length > 0) {
                return state.event.guests.filter(item => {
                    if (item.person) {
                        return item.status === "attending";
                    }
                });
            } else {
                return [];
            }
        },
        attending_kids: state => {
            if (state.event && state.event.guests && state.event.guests.length > 0) {
                return state.event.guests.filter(item => {
                    if (item.person) {
                        return (item.person.age_group === "child") & (item.status === "attending");
                    }
                });
            } else {
                return [];
            }
        },
        attending_adults: state => {
            if (state.event && state.event.guests && state.event.guests.length > 0) {
                return state.event.guests.filter(item => {
                    if (item.person) {
                        return (item.person.age_group === "adult") & (item.status === "attending");
                    }
                });
            } else {
                return [];
            }
        }
    },
    actions: {
        async invite_to_event({ commit }, payload) {
            let errors = [];
            let data = {
                guest_ids: this.state.StoreEvent.guest_ids,
                event_id: payload,
                action: "invite_guests_to_event"
            };
            if (errors.length === 0) {
                try {
                    let response = await axios.post(settings.api_url + "/event-guests/", data);
                    if (response && response.data) {
                        commit("set_guest_ids", []);

                        if (response.data.success === 1) {
                            router.push({
                                path: "/events/" + payload + "/guests"
                            });
                        } else {
                            router.push({
                                path: "/error/"
                            });
                        }
                    }
                } catch (error) {
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        },
        async get_events({ commit }, page = false) {
            let data = {};
            if (page) {
                data = {
                    current_page: page
                };
            }
            try {
                let response = await axios.get(settings.api_url + "/events/", {
                    params: data
                });
                if (response && response.data) {
                    let events_data = response.data;
                    commit("add_month_events", {
                        events_data: events_data,
                        page: page
                    });
                }
                return true;
            } catch (error) {
                if (error.status === 401) {
                    router.push({ path: "/login" });
                }
                return false;
            }
        },
        async get_event_guests({ commit }, payload) {
            let data = {};
            if (payload) {
                data = {
                    event_id: payload.event_id,
                    sorted_by: payload.sorted_by
                };
            }
            try {
                let response = await axios.get(settings.api_url + "/event-guests/", {
                    params: data
                });
                if (response && response.data) {
                    let guests = response.data.guests;
                    let user_added_persons_count = response.data.user_added_persons_count;
                    commit("add_event_guests", {
                        guests: guests,
                        event_id: payload.event_id,
                        user_added_persons_count: user_added_persons_count
                    });
                }
                return true;
            } catch (error) {
                if (error.status === 401) {
                    router.push({ path: "/login" });
                }
                return false;
            }
        },
        async get_calendar_events({ commit }, page = false) {
            let data = {};
            if (page) {
                data = {
                    current_page: page
                };
            }
            try {
                let response = await axios.get(settings.api_url + "/calendar-events/", {
                    params: data
                });
                if (response && response.data) {
                    let events_data = response.data;
                    commit("add_calendar_events", {
                        events_data: events_data,
                        page: page
                    });
                    return true;
                }
            } catch (error) {
                if (error.status === 401) {
                    router.push({ path: "/login" });
                }
                return false;
            }
        },
        async set_tab({ commit }, payload) {
            commit("set_tab", payload);
        },
        async change_person_event_status({ commit }, payload) {
            try {
                let data = {
                    action: "change_person_event_status",
                    status: payload.status,
                    event_person_id: payload.event_person.id,
                    event_id: this.state.StoreEvent.event.id
                };
                let response = await axios.post(settings.api_url + "/person/", data);
                if (response && response.data) {
                    if (response.data.success === 1) {
                        commit("change_event_guest_status", {
                            event_person: payload.event_person,
                            status: payload.status
                        });
                    } else {
                        router.push({
                            path: "/error/"
                        });
                    }
                }
            } catch (error) {
                if (error.data) {
                    router.push({
                        path: "/error/"
                    });
                } else {
                    router.push({
                        path: "/error/connection-lost"
                    });
                }
            }
        },
        async get_event({ commit }, payload) {
            try {
                let response = await axios.get(settings.api_url + "/event/", {
                    params: {
                        event_id: payload
                    }
                });
                if (response && response.data) {
                    let event_data = response.data.event;
                    let event = {
                        id: event_data.id,
                        name: event_data.name,
                        location: event_data.location ? event_data.location : null,
                        recurring: event_data.recursion ? event_data.recursion : null,
                        time: event_data.time ? event_data.time : null,
                        event_time: event_data.event_time ? event_data.event_time : null,
                        date: event_data.date ? event_data.date : null,
                        budget: event_data.budget ? event_data.budget : null,
                        event_type: event_data.event_type ? event_data.event_type : null,
                        notes: event_data.notes ? event_data.notes : null,
                        tasks: event_data.tasks ? event_data.tasks : [],
                        guests: event_data.guests ? event_data.guests : [],
                        attendees: event_data.attendees ? event_data.attendees : []
                    };
                    commit("set_event", event);
                } else {
                    commit("set_event_loaded", true);
                }
            } catch (error) {
                commit("set_event_loaded", true);
                console.log(error);
                if (error.status === 403) {
                    router.push({ path: "/events/" });
                }
            }
        },
        async get_task_event({ commit }, payload) {
            try {
                let response = await axios.get(settings.api_url + "/event-task/", {
                    params: {
                        id: payload
                    }
                });
                if (response && response.data) {
                    let event_task_data = response.data.event_task;
                    let event_task = {
                        id: event_task_data.id,
                        name: event_task_data.name,
                        event_id: event_task_data.event_id,
                        time: event_task_data.deadline ? moment(event_task_data.deadline).format("HH:mm") : null,
                        done_date: event_task_data.done_date ? event_task_data.done_date : null,
                        status: event_task_data.status ? event_task_data.status : null,
                        date: event_task_data.date ? event_task_data.date : null,
                        notes: event_task_data.notes ? event_task_data.notes : null
                    };
                    commit("set_task_event", event_task);
                } else {
                }
            } catch (error) {
                console.log(error);
                if (error.status === 403) {
                    router.push({ path: "/events/" });
                } else {
                    router.push({
                        path: "/error/"
                    });
                }
            }
        },
        async save_event({ commit }, payload) {
            let errors = [];
            let data = payload;
            let fields_to_validate = ["name", "date", "time"];
            fields_to_validate.forEach(f => {
                if (!payload[f]) {
                    errors.push(f);
                }
            });

            commit("set_errors", errors);
            commit("set_event_add_error", false);

            if (errors.length === 0) {
                try {
                    let response = await axios.post(settings.api_url + "/event/", data);
                    if (response && response.data) {
                        commit("set_btn_loading", false);
                        if (response.data.success === 1) {
                            commit("set_active_event", {});
                            router.push({
                                path: "/events/" + response.data.event.id
                            });
                        } else {
                            router.push({
                                path: "/error/"
                            });
                            commit("set_event_add_error", true);
                        }
                    }
                } catch (error) {
                    commit("set_btn_loading", false);

                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });

                        commit("set_event_add_error", true);
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                        commit("set_event_add_error", true);
                    }
                }
            }
        },
        async save_event_task({ commit }, payload) {
            let errors = [];
            let data = payload;
            let fields_to_validate = ["name"];
            fields_to_validate.forEach(f => {
                if (!payload[f]) {
                    errors.push(f);
                }
                if (payload.time) {
                    if (!payload.date) {
                        errors.push("date");
                    }
                }
            });
            commit("set_task_errors", errors);

            if (errors.length === 0) {
                try {
                    let response = await axios.post(settings.api_url + "/event-task/", data);
                    if (response && response.data) {
                        commit("set_btn_loading", false);
                        if (response.data.success === 1) {
                            commit("set_task", response.data.event_task);
                            //router.back();
                            router.push({
                                path: "/events/" + response.data.event_task.event_id
                            });
                        } else {
                            router.push({
                                path: "/error/"
                            });
                        }
                    }
                } catch (error) {
                    commit("set_btn_loading", false);
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        },
        async delete_event({ commit }, payload) {
            let errors = [];
            commit("set_errors", errors);
            if (errors.length === 0) {
                try {
                    let response = await axios.delete(settings.api_url + "/event/?id=" + payload);
                    if (response && response.data) {
                        if (response.data.success === 1) {
                            router.push({
                                path: "/events/"
                            });
                        } else {
                            router.push({
                                path: "/error/"
                            });
                        }
                    }
                } catch (error) {
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        },
        async delete_recurring_event({ commit }, payload) {
            let errors = [];
            commit("set_errors", errors);
            let url =
                settings.api_url +
                "/events/?id=" +
                payload.event.id +
                "&time=" +
                encodeURIComponent(payload.event.event_time);
            if (payload.type) {
                url =
                    settings.api_url +
                    "/events/?id=" +
                    payload.event.id +
                    "&time=" +
                    encodeURIComponent(payload.event.event_time) +
                    "&type=" +
                    payload.type;
            }
            if (errors.length === 0) {
                try {
                    let response = await axios.delete(url);
                    if (response && response.data) {
                        if (response.data.success === 1) {
                            router.push({
                                path: "/events/"
                            });
                        } else {
                            router.push({
                                path: "/error/"
                            });
                        }
                    }
                } catch (error) {
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        },

        async delete_event_task({ commit }, payload) {
            let errors = [];
            commit("set_errors", errors);
            if (errors.length === 0) {
                try {
                    let response = await axios.delete(settings.api_url + "/event-task/?id=" + payload.event_id);
                    if (response && response.data) {
                        if (response.data.success === 1) {
                            if (payload.from_route && payload.from_route.path) {
                                router.push({
                                    path: payload.from_route.path
                                });
                            } else {
                                router.push({
                                    path: "/events/"
                                });
                            }
                        } else {
                            router.push({
                                path: "/error/"
                            });
                        }
                    }
                } catch (error) {
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        }
    }
};
